<div class="mx-md-0 mx-lg-3 mx-xl-4 mx-xxl-5" style="cursor:pointer" (click)="setTableListButtonClicked()">
	<div class="profile-picture mb-2 profileImgContainer mx-auto" style="height: 8rem;width: 8rem;">
		<table-list-thumbnail *ngIf="thumb.value" [source]="thumb.value" [rounded]="true">
		</table-list-thumbnail>
	</div>
</div>
<div class="alert-card my-2 mx-auto py-2 px-4 alert alert-info" style="width: fit-content;cursor:pointer"
	(click)="setTableListButtonClicked()">
	<h5 class="m-0">{{ title.value }}</h5>
</div>